import { render } from "./CreateCustomerDocuments.vue?vue&type=template&id=0bdc5854&scoped=true"
import script from "./CreateCustomerDocuments.vue?vue&type=script&lang=js"
export * from "./CreateCustomerDocuments.vue?vue&type=script&lang=js"

import "./CreateCustomerDocuments.vue?vue&type=style&index=0&id=0bdc5854&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-0bdc5854"

export default script